import { render } from "./BitkubNextUrl.vue?vue&type=template&id=6ebae475&scoped=true"
import script from "./BitkubNextUrl.vue?vue&type=script&lang=js"
export * from "./BitkubNextUrl.vue?vue&type=script&lang=js"

import "./BitkubNextUrl.vue?vue&type=style&index=0&id=6ebae475&lang=scss&scoped=true"

import exportComponent from "H:\\git\\Net_Web_LandingVue\\vue-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ebae475"]])

export default __exports__